import Vue from "vue";
import Vuex from "vuex";
import home from "./home";
import users from "./users";
import reports from "./reports";
import appointment from "./appointment";
import reference from "./reference";

Vue.use(Vuex);
Vue.config.devtools = process.env.NODE_ENV === "development";

export default new Vuex.Store({
  modules: {
    users,
    home,
    reports,
    appointment,
    reference
  }
});
